import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const rounds = [
  {
    number: '01',
    title: 'Build the Foundation',
    count: '15 tests',
    testStart: 1,
    description: 'Subject learning and revision tests paired with month-wise current affairs and mental ability.',
    tests: [
      'History I - Sep 2025 Current Affairs', 'History II - Oct 2025 Current Affairs',
      'Polity I - Nov 2025 Current Affairs', 'History Revision + Mental Ability',
      'Polity II - Dec 2025 Current Affairs', 'Economy I - Jan 2026 Current Affairs',
      'Polity Revision + Mental Ability', 'Economy II + Economic Survey + Budget',
      'Economy Revision + Mental Ability', 'Geography I - Mar 2026 Current Affairs',
      'Geography II - Apr 2026 Current Affairs', 'Geography Revision + Mental Ability',
      'Environment - May 2026 Current Affairs', 'Science & Technology - Jun 2026 Current Affairs',
      'Environment + Science & Technology Revision'
    ]
  },
  {
    number: '02',
    title: 'Consolidate + Connect',
    count: '5 tests',
    testStart: 16,
    description: 'Bring subjects and current affairs together through focused revision and consolidation.',
    tests: [
      'History - Jul 2026 Current Affairs', 'Polity - Aug 2026 Current Affairs',
      'Geography - Sep 2026 Current Affairs', 'Economy - Oct 2026 Current Affairs',
      'Environment + Science & Technology + consolidated current affairs revision'
    ]
  },
  {
    number: '03',
    title: 'Perform Under Pressure',
    count: '10 tests',
    testStart: 21,
    description: 'Five full-length mock-paper pairs with complete 12-month current affairs coverage.',
    tests: [
      'Full-Length Test 1 - Paper I', 'Full-Length Test 1 - Paper II',
      'Full-Length Test 2 - Paper I', 'Full-Length Test 2 - Paper II',
      'Full-Length Test 3 - Paper I', 'Full-Length Test 3 - Paper II',
      'Full-Length Test 4 - Paper I - PYQ pattern', 'Full-Length Test 4 - Paper II - PYQ pattern',
      'Full-Length Test 5 - Paper I - exam simulation', 'Full-Length Test 5 - Paper II - exam simulation'
    ]
  }
];

const AdhvaDiksoochiKAS2026Page = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateSize = () => setIsMobile(window.innerWidth < 768);
    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const callToActionStyle = {
    display: 'inline-block', padding: '0.9rem 1.5rem', borderRadius: '0.65rem',
    background: '#c28a15', color: '#fff', fontWeight: 700, textDecoration: 'none'
  };

  return (
    <div style={{ background: '#f7f8fa', color: '#0b1938', minHeight: '100vh' }}>
      <Navbar />

      <header style={{ background: 'linear-gradient(135deg, #071934 0%, #0e3563 58%, #c28a15 180%)', color: '#fff', padding: isMobile ? '6rem 1.25rem 4rem' : '8rem 1.5rem 6rem', textAlign: 'center' }}>
        <p style={{ margin: 0, color: '#f3c75f', fontWeight: 700, letterSpacing: '0.12em', fontSize: '0.82rem' }}>KPSC KAS PRELIMS 2026</p>
        <h1 style={{ color: '#ffffff', fontSize: isMobile ? '2.35rem' : '4.2rem', lineHeight: 1, margin: '1rem 0 1.25rem', letterSpacing: '-0.04em' }}>
          ADHVA <span style={{ color: '#f3c75f' }}>DIKSOOCHI</span>
        </h1>
        <h2 style={{ color: '#ffffff', fontSize: isMobile ? '1.25rem' : '1.75rem', margin: 0, fontWeight: 600 }}>Your Compass to KAS Success</h2>
        <p style={{ color: '#ffffff', maxWidth: '42rem', margin: '1.25rem auto 2rem', fontSize: '1.1rem', lineHeight: 1.7 }}>Success needs direction. We show you the path through structured practice, expert review and consistent improvement.</p>
        <a href="https://wa.me/918867198007?text=Hello%20Adhva%20Academy%2C%20I%20would%20like%20to%20know%20more%20about%20Adhva%20Diksoochi%20KAS%202026." target="_blank" rel="noopener noreferrer" style={callToActionStyle}>Book a Free Demo Mentor Call</a>
      </header>

      <main>
        <section className="container" style={{ maxWidth: '1120px', margin: '0 auto', padding: isMobile ? '3rem 1.25rem' : '5rem 1.5rem' }}>
          <div style={{ textAlign: 'center', maxWidth: '48rem', margin: '0 auto 2.5rem' }}>
            <p style={{ color: '#c28a15', fontWeight: 800, letterSpacing: '0.1em', fontSize: '0.8rem' }}>THE ADHVA ADVANTAGE</p>
            <h2 style={{ fontSize: isMobile ? '2rem' : '2.7rem', margin: '0.5rem 0 1rem' }}>A guided system, not just another test series.</h2>
            <p style={{ fontSize: '1.1rem', lineHeight: 1.7, color: '#46546a' }}>Practice. Review. Improve. Repeat - with a mentor by your side.</p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1rem' }}>
            {[
              ['30', 'Prelims Tests', 'Subject drills, revision cycles and full-length mocks'],
              ['1:1', 'Personal Mentorship', 'Focused review, accountability and next-step planning'],
              ['14', 'Months Current Affairs', 'Integrated with core subjects, Budget and Economic Survey'],
              ['Each', 'Performance Report Card', 'See strengths, gaps and improvement priorities after every test']
            ].map(([stat, title, description]) => (
              <article key={title} style={{ background: '#fff', border: '1px solid #e5e9ef', borderTop: '4px solid #c28a15', borderRadius: '0.85rem', padding: '1.5rem', boxShadow: '0 8px 22px rgba(7,25,52,0.06)' }}>
                <div style={{ color: '#c28a15', fontSize: '2rem', fontWeight: 800 }}>{stat}</div>
                <h3 style={{ margin: '0.65rem 0 0.5rem', fontSize: '1.2rem' }}>{title}</h3>
                <p style={{ margin: 0, lineHeight: 1.55, color: '#536177' }}>{description}</p>
              </article>
            ))}
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', gap: '0.75rem', flexWrap: 'wrap', marginTop: '2rem' }}>
            {['Economic Survey + Budget', 'Online + Offline Support', 'Kannada + English Support'].map(item => <span key={item} style={{ background: '#eaf0f8', color: '#0e3563', borderRadius: '999px', padding: '0.65rem 1rem', fontWeight: 700 }}>{item}</span>)}
          </div>
        </section>

        <section style={{ background: '#eaf0f8', padding: isMobile ? '3rem 1.25rem' : '5rem 1.5rem' }}>
          <div className="container" style={{ maxWidth: '1120px', margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
              <p style={{ color: '#c28a15', fontWeight: 800, letterSpacing: '0.1em', fontSize: '0.8rem' }}>YOUR 30-TEST ROADMAP</p>
              <h2 style={{ fontSize: isMobile ? '2rem' : '2.7rem', margin: '0.5rem 0 0.75rem' }}>Build fundamentals. Consolidate current affairs. Simulate the real exam.</h2>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.25rem' }}>
              {rounds.map(round => (
                <article key={round.number} style={{ background: '#fff', borderRadius: '0.85rem', overflow: 'hidden', boxShadow: '0 8px 22px rgba(7,25,52,0.08)' }}>
                  <div style={{ background: '#0e3563', color: '#fff', padding: '1.25rem' }}>
                    <span style={{ color: '#f3c75f', fontWeight: 800 }}>ROUND {round.number}</span>
                    <h3 style={{ color: '#ffffff', margin: '0.35rem 0', fontSize: '1.4rem' }}>{round.title}</h3>
                    <p style={{ margin: 0, color: '#dbe8f6', fontWeight: 700 }}>{round.count}</p>
                  </div>
                  <div style={{ padding: '1.25rem' }}>
                    <p style={{ marginTop: 0, color: '#536177', lineHeight: 1.55 }}>{round.description}</p>
                    <div style={{ display: 'grid', gap: '0.55rem' }}>
                      {round.tests.map((test, index) => (
                        <div key={test} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.65rem', padding: '0.65rem 0.7rem', background: '#f4f7fb', borderRadius: '0.5rem', borderLeft: '3px solid #c28a15', color: '#1c2c45', lineHeight: 1.4 }}>
                          <span style={{ flexShrink: 0, color: '#0e3563', fontWeight: 800, fontSize: '0.74rem', paddingTop: '0.1rem' }}>
                            T{String(round.testStart + index).padStart(2, '0')}
                          </span>
                          <span style={{ fontSize: '0.9rem' }}>{test}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="container" style={{ maxWidth: '1000px', margin: '0 auto', padding: isMobile ? '3.5rem 1.25rem' : '5rem 1.5rem', textAlign: 'center' }}>
          <h2 style={{ fontSize: isMobile ? '2rem' : '2.7rem', margin: '0 0 1rem' }}>Every test becomes your next step.</h2>
          <p style={{ color: '#536177', fontSize: '1.1rem', maxWidth: '42rem', margin: '0 auto 2rem', lineHeight: 1.65 }}>A structured feedback loop turns performance into a practical preparation plan through one-to-one reviews, report cards and bilingual support.</p>
          <p style={{ fontSize: '1.25rem', fontWeight: 800, color: '#0e3563', marginBottom: '1.5rem' }}>Ready to prepare with purpose?</p>
          <a href="https://wa.me/918867198007?text=Hello%20Adhva%20Academy%2C%20I%20would%20like%20to%20book%20a%20free%20demo%20mentor%20call%20for%20Adhva%20Diksoochi%20KAS%202026." target="_blank" rel="noopener noreferrer" style={callToActionStyle}>Call or WhatsApp to Reserve Your Seat</a>
          <p style={{ marginTop: '1.25rem', color: '#536177', fontWeight: 700 }}>+91 88671 98007 / +91 88671 93007 · Kuvempunagar, Mysuru</p>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default AdhvaDiksoochiKAS2026Page;
